import { createSelector } from '@reduxjs/toolkit'

import {
  getUserSelector,
  skipUpdateLegalsSCDisabledSelector,
  skipUpdateLegalsScEnabledSelector,
} from 'store/modules/user/selectors'
import type { ReduxState } from 'store/types'

export const getAppConfig = (state: ReduxState) => state.appConfig

export const getIsSoftKycRequiredEnabledSelector = createSelector(
  getAppConfig,
  (appConfig) => appConfig.softKycRequiredEnabled,
)
export const getSoftKycRequiredEnabledSelector = getIsSoftKycRequiredEnabledSelector
export const getdarkThemeSelector = createSelector(getAppConfig, (appConfig) => appConfig.darkTheme)
export const isAppInitializedSelector = createSelector(getAppConfig, (appConfig) => appConfig.init)
export const getIsPWAMessageOpenSelector = createSelector(getAppConfig, (appConfig) => appConfig.isPWAMessageOpen)
export const getPasswordPolicySelector = createSelector(getAppConfig, (appConfig) => appConfig.passwordPolicy)
export const sweepstakeEnabledSelector = createSelector(getAppConfig, (appConfig) => appConfig.sweepstakeEnabled)
export const getLocationDataSelector = createSelector(getAppConfig, (appConfig) => appConfig.location)
export const getForcementModeSelector = createSelector(getAppConfig, (appConfig) => appConfig.forcement)

export const isLegalsUpdatedAvailableSelector = createSelector(
  sweepstakeEnabledSelector,
  skipUpdateLegalsScEnabledSelector,
  skipUpdateLegalsSCDisabledSelector,
  (scEnable, skipLegalScEnable, skipLegalScDisable) => {
    const skipScLegalUpdates = scEnable ? skipLegalScEnable : skipLegalScDisable
    const isScLegalUpdates = !skipScLegalUpdates

    return isScLegalUpdates
  },
)

// [FYI]: A/B testing 3rd party checks
export const isThirdPartyCheckEnabledSelector = createSelector(
  getAppConfig,
  (appConfig) => appConfig.thirdPartyCheckEnabled,
)
export const getThirdPartyCheckEnabledSelector = isThirdPartyCheckEnabledSelector

export const getIsAcceptedRulesForScUser = createSelector(
  getUserSelector,
  sweepstakeEnabledSelector,
  (user, sweepstakeEnabled) => {
    const isActualTC = user?.acceptedTcVersion === user?.tcVersion
    const isActualSR = user?.acceptedSrVersion === user?.srVersion

    return isActualTC && (!sweepstakeEnabled || isActualSR)
  },
)

export const getImageBasedCaptchaSelector = createSelector(getAppConfig, (appConfig) => appConfig.useImageBasedCaptcha)
